<template>
	<main>
		<header>
			<a href="https://lenta.ru/" @click="linkClick('https://lenta.ru/')" target="_blank">
				<img src="../assets/images/lenta.svg">
			</a>

			<a
					href="https://www.kia.ru/models/sportage/desc/?utm_source=special_project&utm_medium=banner&utm_campaign=KIA_Sportage_Tactic_December_2018"
					@click="linkClick('https://www.kia.ru/models/sportage/desc/?utm_source=special_project&utm_medium=banner&utm_campaign=KIA_Sportage_Tactic_December_2018')"
					target="_blank"
			>
				<img src="../assets/images/kia.svg">
			</a>
<!--
			<br v-if="device === 'desktop'">

			<a
					:href="learnmoreLink"
					class="learnmore1"
					@click="linkClick('learnmore top')"
					target="_blank"
			>
				Подробнее о KIA Sportage
			</a>
-->
			<shares class="shares"/>
		</header>

		<section id="intro" :style="introBg">
			<img v-if="device === 'mobile'" :src="getImg('intro-bg-mobile.jpg')" class="bg">

			<slot name="intro"></slot>

			<div class="scroll-down" v-scroll-to="'#block-1'">llorcs</div>

			<ul class="sides">
				<li>+ твой успех +</li>
				<li>+ твой KIA +</li>
			</ul>
		</section>

		<div class="main">
			<section class="programs">
				<slot name="programs"></slot>
			</section>

			<div class="banner" id="banner">
				<img :src="getImg('banner.jpg')">
			</div>

			<section class="programs programs-bottom">
				<slot name="programs_bottom"></slot>
			</section>

		</div>
		<section id="product" :class="[ route ]">
			<div class="title" :style="{ backgroundColor: color }">
				<h2>KIA</h2>
			</div>

			<div class="center">
				<img :src="getImg('product.png')">
			</div>

			<div class="text">
				<template v-if="device === 'desktop'">
					<h3 v-collide="'fadeInLeft'">Продукт</h3>
					<p v-collide="'fadeInUp'">
						<slot name="product"/>
					</p>
				</template>

				<template v-else>
					<h3>Продукт</h3>
					<p>
						<slot name="product"/>
					</p>
				</template>
			</div>
		</section>
<!--
		<TestDrive :page="route" :color="color"/>-->
	</main>
</template>


<script>
    import { mapState } from 'vuex'
    import shareMixin from '@/mixins/shares'
    import Shares from '@/components/Shares'
    import TestDrive from '@/components/TestDrive'

    // import Parallax from '@/utils/parallax'

    import LINKS from '@/data/links';

    export default {
        name: 'Content',
        mixins: [shareMixin],
        components: {
            Shares,
            TestDrive,
        },
        props: {
            color: {
                type: String,
                required: true,
            },
        },
        data() {
            return {


            }
        },
        mounted() {
            document.body.scrollTop = 0
        },
        methods: {
            getImg(name) {
                return require(`@/assets/images/${this.$route.name}/${name}`)
            },

            check() {
                this.checked = !this.checked
            },
        },
        computed: {
            ...mapState({
                device: state => state.device,
            }),
            introBg() {
                let bg = require(`@/assets/images/${this.route}/intro-bg.jpg`)

                return { backgroundImage: `url(${bg})` }
            },
            route() {
                return this.$route.name
            },
            learnmoreLink() {
                return LINKS[this.route]
            },
        },
        watch: {
            email(email) {
                if (email.length) {
                    this.error = false
                    this.placeholder = 'Ваш e-mail'
                }
            },
        },
    }
</script>


<style lang="less">
	@import '../styles/variables';

	main {
		position: relative;
		font-size: 0;
	}
	.main {
		background: url('../assets/images/bg-2.png') repeat-y center center;
		background-size: 100vw;
	}
	header {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
		padding: 20px;
		box-sizing: border-box;
		z-index: 2;

		@media (min-width: 1200px) {
			padding: 40px 70px;
		}

		@media (min-width: 960px) {
			flex-wrap: wrap;
		}

		a {
			width: 65px;

			@media (min-width: 720px) {
				width: 80px;
			}

			&:first-of-type {
				margin-right: 60px;

				@media (min-width: 720px) {
					margin-right: 60px;
				}
			}

			img {
				width: 100%;
			}
		}

		a.learnmore1 {
			width: 260px;
			height: 40px;
			margin-left: 20px;
			text-align: center;
			color: #fff;
			font-size: 13px;
			letter-spacing: 2px;
			border: 1px solid #fff;
			opacity: 0.7;
			transition: all 300ms ease;
			display: flex;
			justify-content: center;
			align-items: center;
			text-transform: uppercase;

			&:hover {
				opacity: 1;
			}

			@media (max-width: 500px) {
				border: none;
				margin-left: 10px;
				letter-spacing: 1px;
				opacity: 1;
			}

			@media (min-width: 960px) {
				margin-top: 20px;
				margin-left: 0;
			}
		}

		br {
			content: '';
			display: block;
			width: 100%;
			height: 0px;
		}

		.shares {
			margin-left: auto;
		}
	}

	section {
		position: relative;
	}

	.center {
		height: 100%;
	}

	h2 {
		text-transform: uppercase;
	}
	h6 {
		font-size: 18px;
		font-weight: 300;
		font-family: @font-bold;
		margin-top: 10px;
		margin-bottom: 10px;
	}


	section#intro {
		position: relative;
		background-color: #191919;
		background-size: cover;
		box-shadow: 0 10px 40px fade(#000, 15%);
		z-index: 1;

		@media (max-width: 959px) {
			background-image: none !important;
		}

		@media (min-width: 960px) {
			height: 60vw;
		}

		img.bg {
			width: 100%;
			margin-bottom: 120px;
			box-shadow: 0 10px 40px fade(#000, 15%);
		}

		.text {
			z-index: 1;

			@media (min-width: 960px) {
				position: absolute;
				left: 40px;
				bottom: 100px;
			}

			@media (min-width: 1200px) {
				left: 50px;
			}
		}

		h1 {
			font-family: @font-bold;
			font-size: 32px;
			line-height: 1;
			margin-bottom: 0.5em;
			text-transform: uppercase;

			@media (min-width: 720px) {
				margin-bottom: 0.3em;
				font-size: 60px;
			}

			@media (min-width: 1300px) {
				font-size: 80px;
			}
		}

		p {
			max-width: 720px;
			font-family: @font-light;
			font-size: 18px;
			line-height: 1.3;
		}

		.wrap {
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-bottom: 30px;

			@media (min-width: 720px) {
				flex-direction: row;
				margin-top: 30px;
			}

			@media (min-width: 960px) {
				margin-bottom: 0;
			}

			img {
				width: 100%;
				max-width: 150px;
				margin: 30px 0;
				border-radius: 50%;

				@media (min-width: 720px) {
					max-width: 90px;
					margin: 0;
					margin-right: 30px;
				}
			}

			p {
				width: 100%;

				@media (min-width: 720px) {
					max-width: 560px;
				}
			}
		}

		.sides {
			display: flex !important;
			align-items: flex-start;
			margin: auto;
			top: 25vw;

			@media (max-width: 959px) {
				li:last-of-type {
					margin-top: 80vw;
				}
			}

			@media (min-width: 960px) {
				align-items: flex-end;
				top: 50%;
				transform: translateY(-50%);
			}
		}
	}

	.scroll-down {
		position: absolute;
		left: 0;
		right: 0;
		margin: auto;
		font-family: @font-regular;
		font-size: 16px;
		letter-spacing: 1.8em;
		text-align: center;
		text-transform: uppercase;
		cursor: pointer;
		user-select: none;
		unicode-bidi: bidi-override;
		direction: rtl;

		@media (max-width: 959px) {
			top: 140vw;
		}

		@media (min-width: 960px) {
			bottom: 40px;
		}

		&::first-letter {
			letter-spacing: 0;
		}

		&:before,
		&:after {
			content: '';
			position: absolute;
			left: 0;
			right: 0;
			bottom: -5em;
			margin: auto;
			height: 4em;
			width: 1px;
			background-color: #fff;
		}

		&:before {
			transform: translate(-0.25em, 0);
		}

		&:after {
			transform: translate(0.25em, 0.75em);
		}
	}

	.programs {
		margin-top: -70px;
		padding-top: 120px;
	}



	.program-header {
		h3 {
			position: relative;
			display: block;
			text-transform: uppercase;
			font-family: 'kia-bold', sans-serif;
			font-size: 28px;
			margin-top: 0;
			margin-bottom: 0.4em;
			z-index: 1;
		}

		img {
			position: relative;
			width: calc(~'100% + 40px');
			z-index: 2;
			display: block;
			margin-top: 30px;
			@media (max-width: 959px) {
				left: -20px;
			}

			@media (min-width: 960px) {
				left: 5%;
				width: 100%;
				max-width: 80%;

			}
		}

		.text {
			margin-bottom: 30px;
			z-index: 3;

			@media (min-width: 960px) {
				position: relative;
				left: 5%;
				bottom: 5%;
				margin-bottom: 0;
			}
		}

		h2 {
			position: relative;
			display: inline-block;
			font-family: @font-bold;
			font-size: 36px;
			margin-top: 2em;
			margin-bottom: 0.4em;
			z-index: 1;
			@media (min-width: 960px) {
				font-size: 56px;
			}
		}

		p {
			position: relative;
			font-family: @font-light;
			font-size: 16px;
			z-index: 1;
		}
	}


	.program-block {

		.text {
			font-family: @font-light;
			font-size: 15px;
			line-height: 1.5;
			p {
				margin-top: 16px;
			}
			ul {
				margin-top: 16px;
			}
			li {
				list-style-type: circle;
			}
		}
		.bigger {
			font-size: 18px;
		}
		h4 {
			font-size: 20px;
			position: relative;
			margin-bottom:  30px;
			span {
				position: relative;
				z-index: 1;
			}
			&:after {
				font-family: @font-bold;
				display: block;
				font-size: 100px;
				color: #000;
				position: absolute;
				z-index: 0;
				top: -50px;
				left: 24px;
			}
		}
	}
	.program-block-1 {
		h4:after {
			content: "1";
		}
	}
	.program-block-2 {
		h4:after {
			content: "2";
		}
	}
	.program-block-3 {
		h4:after {
			content: "3";
		}
	}

	.button {
		position: relative;
		cursor: pointer;
		display: block;
		transition: opacity .25s;
		&.hidden {
			opacity: 0;
		}
		&:after {
			content: "";
			display: block;
			position: absolute;
			z-index: 0;
			width: 320px;
			height: 60px;
			left: -50px;
			bottom: -25px;
			background: #000;
		}
		@media (min-width: 960px) {
			.button:after {
				width: auto;
			}
		}


		span {
			z-index: 1;
			width: 320px;
			height: 60px;
			text-align: center;
			color: #fff;
			font-size: 13px;
			letter-spacing: 5px;
			border: 1px solid #fff;
			transition: all 300ms ease;
			display: flex;
			justify-content: center;
			text-transform: uppercase;
			align-items: center;
			position: relative;
			z-index: 1;
		}
	}

	#banner {
		position: relative;
		width: 100%;
		box-shadow: 0 0 60px fade(#000, 50%);
		z-index: 1;

		img {
			width: 100%;
		}

		.learnmore2 {
			width: 260px;
			height: 50px;
			text-align: center;
			color: #000;
			font-size: 13px;
			letter-spacing: 2px;
			background: #fff;
			transition: all 300ms ease;
			display: flex;
			justify-content: center;
			text-transform: uppercase;
			align-items: center;
			position: absolute;
			top: 5%;
			right: 5%;

			&:hover {
				background: #000;
				color: #fff;
			}

			@media (max-width: 500px) {
				height: 40px;
				opacity: 1;
				left: 50%;
				transform: translateX(-50%);
				right: 0;
			}
		}
		&:before {
			 content: "";
			 display: block;
			 position: absolute;
			 left: 5%;
			 top: -100px;
			 width: 240px;
			 height: 120px;
			 background: url('../assets/images/lines-white.png') no-repeat center center;
			 background-size: contain;
		}
		&:after {
			content: "";
			display: block;
			position: absolute;
			left: 0;
			bottom: -100px;
			width: 240px;
			height: 120px;
			background: url('../assets/images/lines-black.png') no-repeat center center;
			background-size: contain;
		}
	}
	.programs-bottom-subscribe {
		margin-top: 60px;
		.button {
			position: relative;
			left: 5%;
			&:after {
				transform: skew(-45deg);
			}
		}
	}

	.programs-bottom-forms {
		position: relative;
		@media (max-width: 959px) {
			margin-top: 120px;
		}
		&:before {
			content: "";
			display: block;
			position: absolute;
			left: 0;
			top: 0;
			width: 120px;
			height: 70px;
			background: url('../assets/images/arrows-double-2.png') no-repeat center center;
			background-size: contain;
		}
		.inner {
			position: relative;
			margin-left: auto;
			text-align: center;
			font-size: 16px;
			display: flex;
			flex-direction: column;
			align-items: center;

			@media (min-width: 960px) {
				right: 5%;
				width: 40%;
				top: -210px;
			}
			h2 {
				font-family: @font-bold;
				font-size: 48px;
			}
			p {
				font-family: @font-light;
				margin-top: 20px;
				margin-bottom: 30px;
			}
			.button {
				@media (min-width: 960px) {
					span {
						width: 360px;
					}
				}
				&:after {
					left: auto;
					right: -45px;
				}
			}
		}
	}


	.programs-bottom {
		padding-bottom: 120px;

		@media (min-width: 480px) {
			padding-bottom: 200px;
		}

		@media (min-width: 720px) {
			padding-bottom: 220px;
		}

		.center {
			z-index: 2;
		}



		img.block-image {
			position: relative;
			width: calc(~'100% + 40px');
			z-index: 1;

			@media (max-width: 959px) {
				margin-top: -30%;
				left: -20px;
			}

			@media (min-width: 960px) {
				position: absolute;
				top: -15%;
				right: 0;
				width: 100%;
				max-width: 45%;
			}
		}

		img.collage {
			max-width: 100%;
			& + p {
				margin-top: 50px;
			}
		}


		.shares {
			display: flex;
			margin-top: -55px;

			a {
				width: 35px;
				height: 35px;
				margin: 20px 0 30px;
				margin-right: 20px;

				&:last-of-type {
					margin-right: 0;
				}
			}

			& + p {
				max-width: 680px;
			}
		}

		button {
			color: #fff;
		}

		button.show-form,
		button.send {
			padding: 0 2.8em;
			font-family: @font-light;
			font-size: 17px;
			line-height: 3.2;
			text-transform: uppercase;
			letter-spacing: 0.4em;
			border: 1px solid #fff;
			transition: all 0.2s;

			@media (max-width: 719px) {
				width: 100%;
				text-align: center;
			}

			&:hover,
			&.active {
				&.art {
					background-color: @color-art;
					border: 1px solid @color-art;
				}

				&.business {
					background-color: @color-business;
					border: 1px solid @color-business;
				}

				&.career {
					background-color: @color-career;
					border: 1px solid @color-career;
				}

				&.family {
					background-color: @color-family;
					border: 1px solid @color-family;
				}

				&.sport {
					background-color: @color-sport;
					border: 1px solid @color-sport;
				}
			}

			&.active {
				pointer-events: none;
			}

			@media (max-width: 959px) {
				&.art {
					background-color: @color-art;
					border: 1px solid @color-art;
				}

				&.business {
					background-color: @color-business;
					border: 1px solid @color-business;
				}

				&.career {
					background-color: @color-career;
					border: 1px solid @color-career;
				}

				&.family {
					background-color: @color-family;
					border: 1px solid @color-family;
				}

				&.sport {
					background-color: @color-sport;
					border: 1px solid @color-sport;
				}
			}
		}

		button.show-form {
			margin-top: 2.5em;
			opacity: 0;
			transition: all 0.2s;
			pointer-events: none;

			&.visible {
				opacity: 1;
				pointer-events: all;
			}
		}

		button.checkbox {
			display: flex;
			align-items: center;
			margin: 2.5em 0;
			font-size: 14px;
			text-align: left;

			&.checked {
				span::after {
					opacity: 1;
				}
			}

			&.art {
				span::after {
					background-color: @color-art;
				}
			}

			&.business {
				span::after {
					background-color: @color-business;
				}
			}

			&.career {
				span::after {
					background-color: @color-career;
				}
			}

			&.family {
				span::after {
					background-color: @color-family;
				}
			}

			&.sport {
				span::after {
					background-color: @color-sport;
				}
			}

			span {
				flex-shrink: 0;
				position: relative;
				width: 16px;
				height: 16px;
				margin-right: 1em;
				border-radius: 50%;
				background-color: #fff;

				&:after {
					content: '';
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					margin: auto;
					width: 10px;
					height: 10px;
					border-radius: 50%;
					background-color: #f00;
					opacity: 0;
					transition: opacity 0.2s;
				}
			}
		}

		button.send {
			&:disabled {
				opacity: 0.5;
				pointer-events: none !important;
			}
		}

		form {
			position: relative;
			margin-top: -56px;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			opacity: 0;
			pointer-events: none;
			transition: all 0.2s;

			&.visible {
				opacity: 1;
				pointer-events: all;

				button {
					pointer-events: all;
				}
			}

			&.success {
				input,
				button.checkbox {
					opacity: 0.5 !important;
					pointer-events: none !important;
				}
			}
		}

		input {
			width: 100%;
			margin-bottom: 1.2em;
			padding: 0.6em 1em;
			font-family: @font-regular;
			font-size: 18px;
			color: #fff;
			background-color: #2d2d2d;
			border: none;
			border-radius: 0;
			box-sizing: border-box;

			@media (min-width: 720px) {
				max-width: 460px;
			}

			&:last-of-type {
				margin-bottom: 0;
			}

			&::placeholder {
				color: #fff;
				transition: all 0.2s;
			}

			&:focus {
				outline: none;

				&::placeholder {
					opacity: 0;
				}
			}

			&.error {
				&::placeholder {
					color: #f00;
				}
			}
		}

		.sides {
			bottom: 200px;
		}
	}

	section#product {
		padding-bottom: 40px;
		background-color: #fff;

		@media (min-width: 960px) {
			padding-bottom: 150px;
		}

		&.business {
			background: linear-gradient(to bottom, rgba(238, 238, 238, 1) 70%, rgba(255, 255, 255, 1) 100%);

			h2 {
				color: #eee;
			}
		}

		&.sport {
			background: linear-gradient(to bottom, #e3e3e3 70%, rgba(255, 255, 255, 1) 100%);

			h2 {
				color: #e3e3e3;
			}
		}

		.title {
			position: relative;
			height: 20vw;

			@media (min-width: 960px) {
				height: 180px;
			}
		}

		h2 {
			position: absolute;
			left: 0;
			bottom: 0;
			font-size: 35vw;
			font-family: @font-bold;
			line-height: 0.7;
			text-transform: none;
			user-select: none;
			z-index: 1;

			@media (min-width: 960px) {
				left: 30px;
				font-size: 300px;
			}

			&:before {
				content: '';
				position: absolute;
				left: -30px;
				top: -80%;
				width: 200%;
				height: 180%;
				background-image: url('../assets/images/dots.png');
				background-size: auto 100%;
				background-repeat: no-repeat;
				z-index: -1;
			}

			&:after {
				content: 'Sportage';
				position: absolute;
				top: 0;
				left: 100%;
				font-size: 0.3em;
			}
		}

		img {
			position: relative;
			margin-top: -10%;
			max-width: 100%;
			z-index: 2;
		}

		.text {
			width: 100%;
			max-width: 880px;
			margin: auto;
			padding: 0 20px;
			box-sizing: border-box;
		}

		h3,
		p {
			color: #000;
		}

		h3 {
			font-size: 36px;
			line-height: 1;
			margin-top: 0.6em;
			margin-bottom: 0.6em;
			font-family: @font-bold;
			text-transform: uppercase;

			@media (min-width: 960px) {
				margin-top: 0;
				font-size: 40px;
			}
		}

		p {
			font-size: 18px;
			line-height: 1.4;

			@media (min-width: 960px) {
				line-height: 1.2;
			}
		}
	}
	.row-with-picture {
		display: flex;
		align-items: center;
		@media (max-width: 959px) {
			flex-direction: column;
			img {
				max-width: 100%!important;
			}
		}
	}
</style>
